<template>
    <router-view />
</template>

<script>
export default {
  //暴露父页面的方法
  //xizhe提交测试
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isReloadData: true,
    }
  },
  methods: {
    //刷新事件
    reload() {
      this.isReloadData = false;
      this.$nextTick(() => {
        this.isReloadData = true;
      });
    }
  }
};

</script>

<!--"element-ui": "^2.15.1"依赖删除-->
<style>
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css";
</style>
